import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-veroeffentlichen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungVeroeffentlichenEffects {

    VeranstaltungVeroeffentlichen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNG_VEROEFFENTLICHEN),
        mergeMap((x: ac.PostVeranstaltungVeroeffentlichenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungVeroeffentlichen(x.veranstaltungRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungVeroeffentlichenErfolgreichAction(result, x.veranstaltungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungVeroeffentlichenFehlerAction(error, x.veranstaltungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
